'use client';

import type { HeroSearch as Props } from '@/app/generated/graphql';

export const MOBILE_IMAGE_HEIGHT = 420;
export const HALF_MOBILE_IMAGE_HEIGHT = MOBILE_IMAGE_HEIGHT / 2;

type HeroImageProps = Pick<Props, 'image' | 'mobileImage'> & {
  formHeight: number;
};

export const HeroImage = ({
  image,
  mobileImage,
  formHeight,
}: HeroImageProps) => (
  <>
    <div
      style={{ backgroundImage: `url(${image?.url})` }}
      className="absolute top-[calc(50%)] hidden w-full translate-y-[-50%] rounded-l-rad-b bg-gradient-to-br from-pink-500 to-pink-700 md:col-span-11 md:col-start-2 md:block md:h-[460px] md:rounded-rad-b md:bg-none md:bg-cover md:bg-center lg:h-[480px]"
      data-testid="hero-image"
    />
    {mobileImage?.url ? (
      <div
        style={{
          backgroundImage: `url(${mobileImage.url})`,
          marginTop:
            formHeight > HALF_MOBILE_IMAGE_HEIGHT
              ? formHeight - HALF_MOBILE_IMAGE_HEIGHT
              : '1rem',
        }}
        className="absolute mb-e h-[420px] w-full bg-cover bg-no-repeat md:hidden"
        data-testid="hero-mobile-image"
      />
    ) : (
      <div
        style={{
          marginTop:
            formHeight > HALF_MOBILE_IMAGE_HEIGHT
              ? formHeight - HALF_MOBILE_IMAGE_HEIGHT
              : '1rem',
        }}
        className="absolute h-[420px] w-full bg-gradient-to-br from-pink-500 to-pink-700 md:hidden"
      />
    )}
  </>
);
